import { NgClass } from "@angular/common";
import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { MoodRequestFormComponent } from "./mood-request-form/mood-request-form.component";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { Mood, TimelineItem } from "@teammood/timeline";

@Component({
    selector: 'user-request-dialog',
    templateUrl: './user-request-dialog.component.html',
    styleUrls: ['./../../timeline-item/timeline-item.scss', './user-request-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        MoodRequestFormComponent,
        MatDialogTitle,
        TranslateModule,
        MatDialogContent,
        NgClass,
        MatDialogActions,
    ]
})
export class UserRequestDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: MoodRequestDialogData,
        private dialogRef: MatDialogRef<UserRequestDialogComponent>,
        private log: LoggerService,
    ) {}

    protected close() {
        this.dialogRef.close(this.data.item);
    }

    protected save (item: TimelineItem){
        switch(item.itemType){
            case 'moodItem':
                this.dialogRef.close(this.data.item);
                break;
            default:
                this.log.error('itemType not recognized');
                break;
        }
    }
}

interface MoodRequestDialogData {
    requestType: string;
    item: Mood;
    teamId: string;
}